import config from '@/config'

// note:判断业务类型
const hostNameList = window.location.hostname.split('.')
const hostLength = hostNameList.length
let BUSINESS_TYPE = ''
const isSecondaryDomain = hostLength === 2
if (isSecondaryDomain) {
  // 二级域名
  BUSINESS_TYPE = hostNameList[0]
}else {
  BUSINESS_TYPE = hostNameList[hostNameList.length - 2]
}

// note:二级域名增加www 三级域名以及以上不增加任何东西  不走cdn的接口
/**
 *
 // zhumavip.com zhongheschool.com 这些场景
 */

// TODO:要去掉
const NO_CDN_MAP = {
  dev: '//dev-api-noc',
  test: '//test-api-noc',
  uat: '//uat-api-noc',
  pro: '//online-api-noc'
}
let BASE_URL = '/java-api'
if (isSecondaryDomain) {
  BASE_URL = `${window.location.protocol}//www.${window.location.hostname}${BASE_URL}`
}

const NO_CDN_BASE_URL = BASE_URL


// note:开发模式下
if (process.env.IS_DEV) {
  BASE_URL = location.hostname.includes('zhuma') ? config.NODE_ZHUMA_API_HOST : config.NODE_ZHONGHESCHOOL_API_HOST
}


// note:走cdn接口，没有java-api
const CDN_MAP = {
  dev: '//dev-web-api-cdn',
  test: '//test-web-api-cdn',
  uat: '//uat-web-api-cdn',
  pro: '//online-web-api-cdn'
}

const CDN_BASE_URL = `${CDN_MAP[process.env.ENVIRONMENT || 'pro']}.${BUSINESS_TYPE}.com`

export { NO_CDN_BASE_URL, CDN_BASE_URL, BASE_URL }



